module.exports = __webpack_public_path__ + "img/icon-bg.e16f53c5.png";